<template>
  <v-app>
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
          >

            <div class="mx-auto hidden-sm-and-down text-xs-center">
              <v-img
                src="/static/error/500.svg"
              />
            </div>
          </v-flex>
          <v-flex
            xs12
          >
            <div class="text-md-center">
              <h1>500</h1>
              <h2 class="my-3 headline ">
                {{ $t('Sorry, the server is down.') }}
              </h2>
              <div>
                <v-btn
                  color="primary"
                  @click="goBack"
                >
                  {{ $t('Try Again') }}
                </v-btn>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="css">
h1 {
  font-size: 150px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px, rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
